"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { Plus, Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Input as AriaInput, Label, Text } from "react-aria-components";
type ArrayInputProps = {
  label?: string;
  name?: string;
  description?: string;
  errorMessage?: string;
  className?: string;
  inputClassName?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
};
export const ArrayInput = t0 => {
  const $ = _c(51);
  const {
    label,
    description,
    errorMessage,
    className,
    value: t1,
    onChange
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const value = t2;
  let t3;
  if ($[2] !== value) {
    t3 = Array.isArray(value) && value.length > 0 ? value : [""];
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [items, setItems] = useState(t3);
  let t4;
  if ($[4] !== items || $[5] !== onChange) {
    t4 = () => {
      const newItems = [...items, ""];
      setItems(newItems);
      onChange?.(newItems);
    };
    $[4] = items;
    $[5] = onChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const addItem = t4;
  let t5;
  if ($[7] !== items || $[8] !== onChange) {
    t5 = index => {
      if (index === 0 && items.length === 1) {
        const newItems_0 = [""];
        setItems(newItems_0);
        onChange?.(newItems_0);
      } else {
        const newItems_1 = items.filter((_, i) => i !== index);
        setItems(newItems_1);
        onChange?.(newItems_1);
      }
    };
    $[7] = items;
    $[8] = onChange;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const removeItem = t5;
  let t6;
  if ($[10] !== items || $[11] !== onChange) {
    t6 = () => {
      const newItems_2 = items.map(_temp);
      setItems(newItems_2);
      onChange?.(newItems_2);
    };
    $[10] = items;
    $[11] = onChange;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const clearFirstItem = t6;
  let t7;
  if ($[13] !== items || $[14] !== onChange) {
    t7 = (index_0, newValue) => {
      const newItems_3 = items.map((item_0, i_1) => i_1 === index_0 ? newValue : item_0);
      setItems(newItems_3);
      onChange?.(newItems_3);
    };
    $[13] = items;
    $[14] = onChange;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const updateItem = t7;
  let t8;
  if ($[16] !== items || $[17] !== value) {
    t8 = () => {
      const currentValues = items.filter(_temp2);
      const newValues = Array.isArray(value) ? value.filter(_temp3) : [];
      if (JSON.stringify(currentValues) !== JSON.stringify(newValues)) {
        setItems(value.length > 0 ? value : [""]);
      }
    };
    $[16] = items;
    $[17] = value;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== value) {
    t9 = [value];
    $[19] = value;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  useEffect(t8, t9);
  let t10;
  if ($[21] !== className) {
    t10 = cn("flex flex-col py-3 my-3 gap-2", className);
    $[21] = className;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== label) {
    t11 = label && <Label className="text-title-medium">{label}</Label>;
    $[23] = label;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== addItem || $[26] !== clearFirstItem || $[27] !== errorMessage || $[28] !== items || $[29] !== removeItem || $[30] !== updateItem) {
    let t13;
    if ($[32] !== addItem || $[33] !== clearFirstItem || $[34] !== errorMessage || $[35] !== items.length || $[36] !== removeItem || $[37] !== updateItem) {
      t13 = (item_3, index_1) => {
        const isLastItem = index_1 === items.length - 1;
        const hasContent = item_3.trim().length > 0;
        const isFirstItem = index_1 === 0;
        return <div key={index_1} className="flex gap-2 items-center"><AriaInput value={item_3} onChange={e => updateItem(index_1, e.target.value)} className={cn("flex-1 border border-gray-300 bg-white px-4 py-3 h-12 rounded-lg text-body placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:border-primary-600 transition-colors duration-150", errorMessage ? "border-primary-500 focus:ring-primary-600 focus:border-primary-600" : "focus:border-primary-600")} placeholder={`${index_1 + 1}. `} /><div className="flex gap-1 min-w-[80px]">{(isFirstItem ? hasContent : true) && <button type="button" onClick={() => {
              if (isFirstItem && items.length === 1) {
                clearFirstItem();
              } else {
                removeItem(index_1);
              }
            }} className="p-2 text-primary-400 hover:text-primary-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer" title={isFirstItem && items.length === 1 ? "Clear" : "Delete"}><Trash2 size={16} /></button>}{isLastItem && hasContent && <button type="button" onClick={addItem} className="p-2 text-grey-400 hover:text-grey-600 hover:bg-grey-50 rounded-lg transition-colors" title="Add"><Plus size={16} /></button>}</div></div>;
      };
      $[32] = addItem;
      $[33] = clearFirstItem;
      $[34] = errorMessage;
      $[35] = items.length;
      $[36] = removeItem;
      $[37] = updateItem;
      $[38] = t13;
    } else {
      t13 = $[38];
    }
    t12 = items.map(t13);
    $[25] = addItem;
    $[26] = clearFirstItem;
    $[27] = errorMessage;
    $[28] = items;
    $[29] = removeItem;
    $[30] = updateItem;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[39] !== t12) {
    t13 = <div className="space-y-2">{t12}</div>;
    $[39] = t12;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== description) {
    t14 = description && <Text className="text-body-small">{description}</Text>;
    $[41] = description;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  const t15 = errorMessage || "";
  let t16;
  if ($[43] !== t15) {
    t16 = <Text className="text-body-small-medium text-destructive h-1">{t15}</Text>;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t10 || $[46] !== t11 || $[47] !== t13 || $[48] !== t14 || $[49] !== t16) {
    t17 = <div className={t10}>{t11}{t13}{t14}{t16}</div>;
    $[45] = t10;
    $[46] = t11;
    $[47] = t13;
    $[48] = t14;
    $[49] = t16;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  return t17;
};
function _temp(item, i_0) {
  return i_0 === 0 ? "" : item;
}
function _temp2(item_1) {
  return item_1.trim() !== "";
}
function _temp3(item_2) {
  return item_2.trim() !== "";
}